export const joinFuncs =
    (...args: (Function | undefined)[]) =>
    () =>
        args.forEach((func) => func?.());
